import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import ProductionPricingPage from './pages/ProductionPricingPage';
import { Toaster } from './components/ui/toaster';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/production-pricing" element={<ProductionPricingPage />} />
        </Routes>
        <Toaster />
      </div>
    </Router>
  );
}

export default App;
